import React from 'react';
import { st, classes } from './button.st.css';
export const Button = ({ priority, onClick, dataHook, disabled, children, }) => {
    return (React.createElement("button", { className: st(classes.root, { priority, isDisabled: disabled }), "data-hook": dataHook, onClick: onClick, disabled: disabled }, children));
};
//# sourceMappingURL=button.js.map